import { IBaseEntity } from './base';

export interface IRoleConfig extends IBaseEntity {
  certificates: RoleState;
  groups: RoleState;
  variables: RoleState;
  courses: RoleState;
  resources: RoleState;
  modules: RoleState;
  users: RoleState;
  reports: RoleState;
  systems: RoleState;
  services: RoleState;
}

export enum RoleState {
  DISABLED = -1,
  ENABLED = 0,
}

export enum Role {
  LEARNER = 0,
  MANAGER = 1,
  AUTHOR = 2,
  ADMIN = 3,
  SUPER_ADMIN = 9,
}
